import { createFeatureSelector, createSelector } from '@ngrx/store';
import { PUSH_TAG, PushState } from './push.state';

const PushSelector = createFeatureSelector<PushState>(PUSH_TAG);
export const getActivePush = createSelector(PushSelector, (state: PushState) => state?.activePush);
